import A11yDialog from "a11y-dialog"
import {
  delegateEventListener,
  // triggerEvent,
} from "@oddcamp/js-utils/src/event"
import turboInit from "../utils/turbo-init"

/**
 * Show a modal
 * @param {HTMLElement} modalEl - The modal element
 * @param {HTMLElement} [triggerEl] - The trigger element
 */
function showModal(modalEl, triggerEl) {
  if (!modalEl) return

  let { Modal } = modalEl

  if (!Modal) {
    Modal = new A11yDialog(modalEl)
    modalEl.Modal = Modal

    Modal.on(`show`, () =>
      document.documentElement.classList.add(`--disable-scroll`)
    )
    Modal.on(`hide`, () => {
      document.documentElement.classList.remove(`--disable-scroll`)

      const params = new URLSearchParams(window.location.search)
      params.delete(`show_modal_id`)

      const queryString = params.toString()
      window.history.replaceState(
        {},
        ``,
        window.location.pathname + (queryString ? `?${queryString}` : ``)
      )
    })

    const event = new CustomEvent(`modalInited`, { detail: { triggerEl } })
    modalEl.dispatchEvent(event)
    // triggerEvent(modalEl, `modalInited`)
  }

  Modal.show()
}

delegateEventListener(`[data-modal-show]`, `click`, (e, triggerEl) => {
  e.preventDefault()
  const id = triggerEl.getAttribute(`data-modal-show`)
  const modalEl = document.querySelector(`#modal-${id}`)
  showModal(modalEl, triggerEl)
})

delegateEventListener(`.js--modal-close`, `click`, (e, triggerEl) => {
  const modal = triggerEl.closest(`.modal`)
  if (!modal || !modal.Modal) return

  modal.Modal.hide()
})

// When a form inside a modal is submitted via Turbo, close the modal once the
// submission succeeds. The modal markup may live inside a Turbo Frame that the
// response replaces, but the open dialog would otherwise leave
// `--disable-scroll` on <html>; calling `hide()` runs A11yDialog's cleanup so
// scrolling is restored. Delegated on the document so it also covers modals and
// forms inserted by Turbo Frame updates.
document.addEventListener(`turbo:submit-end`, (event) => {
  if (!event.detail || !event.detail.success) return

  const form = event.target
  if (!form || typeof form.closest !== `function`) return

  const modalEl = form.closest(`.modal`)
  if (modalEl && modalEl.Modal) modalEl.Modal.hide()
})

turboInit(() => {
  const params = new URLSearchParams(window.location.search)
  const modalId = params.get(`show_modal_id`)
  if (!modalId) return

  const modalEl = document.querySelector(`#modal-${modalId}`)
  showModal(modalEl)
})
